import { SCAN_STATE } from '../../../../interfaces/ScanState';

export const STATUS_DISPLAY_MAPPING = {
	[SCAN_STATE.INGESTING]: SCAN_STATE.RUNNING
};
